import { useState, VFC } from 'react'
import { useFeedbacks, useSentFeedbacks } from 'src/api/feedback'
import { useReceivedFeedbackRooms } from 'src/api/room'
import {
  FEEDBACK_EXCELLENT_ICON,
  FEEDBACK_FAIR_ICON,
  FEEDBACK_GOOD_ICON,
} from 'src/assets/images'
import { UserIcon } from 'src/components/Image/UserIcon'
import { MemberPageWrapper } from 'src/components/PageWrapper'
import { Pagination } from 'src/components/Pagination'
import { FeedbackDetail } from 'src/models/Feedback'
import { LoginUser } from 'src/models/User'
import {
  _feedback_blue,
  _feedback_red,
  _feedback_yellow,
  _profilehrborder,
  _tags_management_background,
  black,
  contributionGray,
  mediumGray,
  orange,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled, { css } from 'styled-components'
import { FeedbackCard } from './FeedbackModal/FeedbackCard'

type KeepLayoutProps = KeepContentProps
export const FeedbackLayout: VFC<KeepLayoutProps> = (props) => {
  const { user } = props
  return (
    <>
      <MemberPageWrapper user={user} currentPath="アポイント・評価">
        <FeedbackContent {...props} />
      </MemberPageWrapper>
    </>
  )
}

type KeepContentProps = {
  user: LoginUser
}
const FeedbackContent: VFC<KeepContentProps> = ({}) => {
  const [pageIndex1, setPageIndex1] = useState<number>(1)
  const feedback = useFeedbacks({}, pageIndex1)
  const feedbacks = feedback.data?.feedbacks || []
  const feedbackDetail: FeedbackDetail = feedback.data?.feedbackDetail || {
    feedbackCount: 0,
    fairCount: 0,
    goodCount: 0,
    excellentCount: 0,
    hasViolationsCount: 0,
  }

  const { data: feedbackRoomsData, mutate: mutateFeedbackRooms } =
    useReceivedFeedbackRooms()
  const feedbackRooms = feedbackRoomsData?.feedbackRooms || []

  const [pageIndex2, setPageIndex2] = useState<number>(1)
  const sentFeedback = useSentFeedbacks({}, pageIndex2)
  const sentFeedbacks = sentFeedback.data?.sentFeedbacks || []

  const [currentTab, setCurrentTab] = useState<
    'received_feedback' | 'need_feedback' | 'sent_feedback'
  >('received_feedback')
  const isReceivedFeedback = currentTab === 'received_feedback'
  const isNeedFeedback = currentTab === 'need_feedback'
  const isSentFeedback = currentTab === 'sent_feedback'

  return (
    <FeedbackListContainer>
      <FeedbackTitle>
        <h2>アポイント・評価一覧</h2>
        <p>
          あなたとアポイントをした企業様から頂いた評価を確認できます。
          <br />
          今後のアポイントや商材/サービスのブラッシュアップに是非ご活用ください。
          <br />
          ※評価コメントには率直な文言が記載されている可能性がございますので、閲覧はご自身の判断で行ってください
        </p>
      </FeedbackTitle>
      <FeedbackTabs>
        <FeedbackTabItem
          onClick={() => setCurrentTab('received_feedback')}
          $isCurrent={isReceivedFeedback}
        >
          <p>評価一覧</p>
        </FeedbackTabItem>
        <FeedbackTabItem
          onClick={() => setCurrentTab('need_feedback')}
          $isCurrent={isNeedFeedback}
        >
          <p>企業へ評価する</p>
        </FeedbackTabItem>
        <FeedbackTabItem
          onClick={() => setCurrentTab('sent_feedback')}
          $isCurrent={isSentFeedback}
        >
          <p>送信履歴</p>
        </FeedbackTabItem>
      </FeedbackTabs>
      {isReceivedFeedback ? (
        <ReceivedFeedback>
          <FeedbackWrapper>
            <h1>あなたの評価</h1>
            <FlexAndSpacer>
              <ReceivedFeedbackDetailTotal>
                <h1>受け取った評価数</h1>
                <ReceivedFeedbackDetailTotalCount>
                  {feedbackDetail.feedbackCount}件
                </ReceivedFeedbackDetailTotalCount>
              </ReceivedFeedbackDetailTotal>
              <div>
                <ReceivedFeedbackRightTitle>
                  詳細内訳
                </ReceivedFeedbackRightTitle>
                <ReceivedFeedbackDetail>
                  <ReceivedFeedbackRightTitle>
                    あなたの印象
                  </ReceivedFeedbackRightTitle>
                  <FlexAndSpacer>
                    <ReceivedFeedbackItem>
                      <img src={FEEDBACK_EXCELLENT_ICON} alt="" />
                      <p>
                        <ReceivedFeedbackExcellent>
                          {feedbackDetail.excellentCount}件
                        </ReceivedFeedbackExcellent>
                      </p>
                    </ReceivedFeedbackItem>
                    <ReceivedFeedbackItem>
                      <img src={FEEDBACK_GOOD_ICON} alt="" />
                      <p>
                        <ReceivedFeedbackGood>
                          {feedbackDetail.goodCount}件
                        </ReceivedFeedbackGood>
                      </p>
                    </ReceivedFeedbackItem>
                    <ReceivedFeedbackItem>
                      <img src={FEEDBACK_FAIR_ICON} alt="" />
                      <p>
                        <ReceivedFeedbackFair>
                          {feedbackDetail.fairCount}件
                        </ReceivedFeedbackFair>
                      </p>
                    </ReceivedFeedbackItem>
                  </FlexAndSpacer>
                  <ReceivedFeedbackRightTitle>
                    違反事項
                  </ReceivedFeedbackRightTitle>
                  <ReceivedFeedbackItem>
                    <ReceivedFeedbackViolation>
                      {feedbackDetail.hasViolationsCount}件
                    </ReceivedFeedbackViolation>
                  </ReceivedFeedbackItem>
                </ReceivedFeedbackDetail>
              </div>
            </FlexAndSpacer>
          </FeedbackWrapper>
          <FeedbackWrapper>
            <h1>評価コメント（新着順）</h1>
            {feedbacks.length > 0 ? (
              <>
                {feedbacks.map(
                  (feedback) =>
                    feedback.content && (
                      <FeedbackItem key={feedback.id}>
                        {feedback.content}
                      </FeedbackItem>
                    ),
                )}
                <Pagination
                  itemSize={feedbackDetail.feedbackCount}
                  setIndex={setPageIndex1}
                  forcePage={pageIndex1 - 1}
                />
              </>
            ) : (
              <FeedbackNoContent>評価コメントはありません。</FeedbackNoContent>
            )}
          </FeedbackWrapper>
        </ReceivedFeedback>
      ) : isNeedFeedback ? (
        <FeedbackRoom>
          {feedbackRooms?.length > 0 ? (
            <>
              <FeedbackRoomTitle>
                つながった企業への評価をお願いします
              </FeedbackRoomTitle>
              {feedbackRooms?.map((room) => (
                <FeedbackCard
                  key={room.uniqueId}
                  item={room}
                  mutate={mutateFeedbackRooms}
                />
              ))}
            </>
          ) : (
            <>
              <FeedbackNoContent>
                <FeedbackRoomTitle>
                  現在評価可能な企業はありません。
                </FeedbackRoomTitle>
              </FeedbackNoContent>
              <FeedbackRoomNoContent>
                評価可能になる条件
                <br />
                ・メッセージのやりとりを２往復以上している
                <br />
                ・やりとりを行ってから14日以上経過
                <br />
                上記事項があてはまる企業のみアポイント評価ができます
              </FeedbackRoomNoContent>
            </>
          )}
        </FeedbackRoom>
      ) : isSentFeedback ? (
        <SentFeedback>
          <FeedbackWrapper>
            <h1>送信履歴</h1>
            {sentFeedbacks.length > 0 ? (
              <>
                {sentFeedbacks.map((feedback) => {
                  const feedbackIconSrc =
                    feedback.impressionScore === 'excellent'
                      ? FEEDBACK_EXCELLENT_ICON
                      : feedback.impressionScore === 'good'
                      ? FEEDBACK_GOOD_ICON
                      : feedback.impressionScore === 'fair'
                      ? FEEDBACK_FAIR_ICON
                      : ''
                  return (
                    <FeedbackItem key={feedback.id}>
                      <Flex>
                        <SentFeedbackLeft>
                          <SentFeedbackLeftImage>
                            <UserIcon src={feedback.image} size="70px" />
                          </SentFeedbackLeftImage>
                          <SentFeedbackLeftText>
                            {feedback.companyName}
                          </SentFeedbackLeftText>
                          <SentFeedbackLeftText>
                            {feedback.adminName} / {feedback.position}
                          </SentFeedbackLeftText>
                        </SentFeedbackLeft>
                        <SentFeedbackRight>
                          <FlexAlignCenter>
                            <SentFeedbackLabel>ステータス：</SentFeedbackLabel>
                            {feedback.className === 'Feedback' ? (
                              <SentFeedbackStatusOrange>
                                {feedback.feedbackStatus}
                              </SentFeedbackStatusOrange>
                            ) : (
                              <SentFeedbackStatusGray>
                                {feedback.feedbackStatus}
                              </SentFeedbackStatusGray>
                            )}
                          </FlexAlignCenter>
                          {feedback.className === 'Feedback' && (
                            <>
                              <FlexAlignCenter>
                                <SentFeedbackLabel>
                                  相手の印象：
                                </SentFeedbackLabel>
                                <img src={feedbackIconSrc} alt="" />
                              </FlexAlignCenter>
                              {feedback.feedbackViolationReasonTexts.length >
                                0 && (
                                <FlexAlignCenter>
                                  <SentFeedbackLabel>
                                    違反事項：
                                  </SentFeedbackLabel>
                                  <div>
                                    {feedback.feedbackViolationReasonTexts.map(
                                      (reason) => (
                                        <div key={reason}>{reason}</div>
                                      ),
                                    )}
                                  </div>
                                </FlexAlignCenter>
                              )}
                              {feedback.content && (
                                <FlexAlignCenter>
                                  <SentFeedbackLabel>
                                    コメント：
                                  </SentFeedbackLabel>
                                  <SentFeedbackContent>
                                    {feedback.content}
                                  </SentFeedbackContent>
                                </FlexAlignCenter>
                              )}
                            </>
                          )}
                          <FlexEnd>送信日時：{feedback.sentAt}</FlexEnd>
                        </SentFeedbackRight>
                      </Flex>
                    </FeedbackItem>
                  )
                })}
                <Pagination
                  itemSize={feedbackDetail.feedbackCount}
                  setIndex={setPageIndex2}
                  forcePage={pageIndex2 - 1}
                />
              </>
            ) : (
              <FeedbackNoContent>送信した企業はありません。</FeedbackNoContent>
            )}
          </FeedbackWrapper>
        </SentFeedback>
      ) : (
        <></>
      )}
    </FeedbackListContainer>
  )
}

const FeedbackListContainer = styled.div`
  max-width: 860px;
  margin: 0 auto;
`

const FeedbackTitle = styled.div`
  font-weight: ${fontWeightBold};
  margin-bottom: 24px;

  h2 {
    font-size: 20px;
    margin: 24px 0px;
  }
  p {
    line-height: 20px;
  }
`

const FeedbackTabs = styled.div`
  display: flex;
  padding: 0px 10px;
  max-width: 700px;
  border-bottom: 1px solid ${_profilehrborder};
  margin-bottom: 40px;
`

const FeedbackTabItem = styled.a<{ $isCurrent: boolean }>`
  max-width: 140px;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: ${fontWeightBold};
  text-align: center;
  margin-right: 30px;
  color: ${contributionGray};

  p {
    padding: 16px;
  }

  :hover,
  :focus {
    color: ${orange};
  }

  ${({ $isCurrent }) =>
    $isCurrent &&
    `
      border-bottom: 3px solid ${orange};
      color: ${black};
    `};
`

const ReceivedFeedback = styled.div``

const FeedbackWrapper = styled.div`
  background-color: ${_tags_management_background};
  padding: 24px 40px;
  margin-bottom: 32px;
  border-radius: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  h1 {
    font-size: 20px;
    font-weight: ${fontWeightBold};
    color: ${mediumGray};
  }
`

const Flex = styled.div`
  display: flex;
`

const FlexAndSpacer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ReceivedFeedbackDetailTotal = styled.div`
  width: 240px;
  height: 144px;
  margin-top: 24px;
  margin-left: 12px;
  padding: 20px 0;
  text-align: center;
  background-color: ${truewhite};
  border-radius: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`

const ReceivedFeedbackDetailTotalCount = styled.p`
  margin-top: 12px;
  color: ${_feedback_yellow};
  font-size: 36px;
  font-weight: ${fontWeightBold};
`

const ReceivedFeedbackRightTitle = styled.p`
  font-weight: ${fontWeightBold};
  color: ${mediumGray};
`

const ReceivedFeedbackDetail = styled.div`
  width: 473px;
  background-color: ${truewhite};
  border-radius: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  margin-top: 8px;
`

const ReceivedFeedbackItem = styled.div`
  width: 120px;
  display: flex;
  padding: 12px 0;

  img {
    margin-right: 20px;
  }

  p {
    font-size: 24px;
    font-weight: ${fontWeightBold};
  }
`

const ReceivedFeedbackExcellent = styled.span`
  color: ${_feedback_red};
`

const ReceivedFeedbackGood = styled.span`
  color: ${_feedback_yellow};
`

const ReceivedFeedbackFair = styled.span`
  color: ${_feedback_blue};
`

const ReceivedFeedbackViolation = styled.p`
  padding-left: 50px;
  font-size: 24px;
  font-weight: ${fontWeightBold};
`

const FeedbackItem = styled.div`
  padding: 20px;
  margin-top: 24px;
  font-weight: ${fontWeightBold};
  background-color: ${truewhite};
  border-radius: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  white-space: pre-wrap;
`

const FeedbackNoContent = styled.p`
  line-height: 100px;
  text-align: center;
`

const FeedbackRoom = styled.div``
const FeedbackRoomTitle = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: ${fontWeightBold};
  color: ${mediumGray};
  margin-bottom: 40px;
`

const FeedbackRoomNoContent = styled.div`
  background-color: ${_tags_management_background};
  padding: 20px;
  width: 460px;
  margin: 0 auto;
  border-radius: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  text-align: left;
  font-weight: ${fontWeightBold};
  font-size: 16px;
  color: ${mediumGray};
`

const SentFeedback = styled.div``

const SentFeedbackLeft = styled.div`
  width: 150px;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`

const SentFeedbackRight = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 20px;
`

const SentFeedbackLeftImage = styled.div`
  display: flex;
  justify-content: center;
`

const SentFeedbackLeftText = styled.p`
  font-size: 12px;
  margin-top: 8px;
`

const FlexAlignCenter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`

const SentFeedbackLabel = styled.p`
  width: 100px;
  text-align: right;
  margin-right: 8px;
`

const SentFeedbackStatusCss = css`
  color: ${truewhite};
  padding: 7px 8px;
  border-radius: 12px;
`
const SentFeedbackStatusOrange = styled.div`
  ${SentFeedbackStatusCss}
  background-color: ${orange};
`
const SentFeedbackStatusGray = styled.div`
  ${SentFeedbackStatusCss}
  background-color: ${mediumGray};
`

const SentFeedbackContent = styled.div`
  white-space: pre-wrap;
`

const FlexEnd = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`
